<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="3%")
          span #
        th(width="9%")
          span(:title="$t('ui.phone')") {{ $t("ui.phone") }}
        th(width="9%")
          span(:title="$t('ui.name')") {{ $t("ui.name") }}
        th(width="9%")
          span(:title="$t('ui.email')") {{ $t('ui.email') }}
        th(width="9%")
          span(:title="$t('ui.email') + ' 2'") {{ $t('ui.email') }} 2
        th(width="9%")
          span(:title="$t('ui.email') + ' 3'") {{ $t('ui.email') }} 3
        th.text-center(width="14%" v-if="!isSubAccount")
          span(:title="$t('ui.assignee')") {{ $t("ui.assignee") }}
        th.text-center(width="8%")
          span(:title="$t('ui.status')") {{ $t("ui.status") }}
        th.text-center(width="10%")
          span(:title="$t('ui.urgency')") {{ $t("ui.urgency") }}
        th(width="10%")
          span(:title="$t('ui.remark')") {{ $t("ui.remark") }}
        th(width="10%")
          span(:title="$t('ui.created_by')") {{ $t("ui.created_by") }}
        th(width="10%")
          span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
        th.text-right(width="10%")
          span(:title="$t('ui.modified_by')") {{ $t("ui.modified_by") }}
        th.text-right(width="10%")
          span(:title="$t('ui.modified_date')") {{ $t("ui.modified_date") }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(colspan="20").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="item.phone") {{ item.phone.toString() }}
        td
          span(:title="item.fullname") {{ item.fullname }}
        td
          small.d-block(:title="item.email") {{ item.email }}
        td
          small.d-block(:title="item.email2") {{ item.email2 }}
        td
          small.d-block(:title="item.email3") {{ item.email3 }}
        td.text-center(v-if="!isSubAccount")
          span(:title="item.login_id") {{ item.login_id }}
        td.text-center
          span(:title="item.status") {{ item.status }}
        td.text-center
          span.text-uppercase(:title='$t("ui.urgency_" + item.urgency)') {{ $t("ui.urgency_" + item.urgency) }}
        td
          span(:title="item.remark") {{ item.remark }}
        td.text-right
          span.d-block(:title="item.created_by") {{ item.created_by }}
        td.text-right
          span.d-block(v-if="item.created_on != null" :title="$moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_on).format('YYYY-MM-DD, HH:mm:ss') }}
        td.text-right
          span.d-block(:title="item.modified_by") {{ item.modified_by }}
        td.text-right
          span.d-block(v-if="item.modified_on != null" :title="$moment(item.modified_on).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.modified_on).format('YYYY-MM-DD, HH:mm:ss') }}

</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
    isSubAccount: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false
  }),
  mounted: function() {},
  methods: {}
};
</script>
